<template>
  <div
    class="group flex w-full cursor-pointer px-2.5 py-1.5 font-roboto text-new-black shadow-none"
    @[isPresentation&&`click`]="emit('click:presentation')"
  >
    <MainPageCardsReworkedTeacherContentSrcIcon
      :link="data.entity_source?.url ?? null"
      class="mr-2 mt-[3px] size-4"
    />
    <div>
      <h2
        class="text-clamp-2 pr-4 font-roboto text-[16px] font-medium leading-[22px]"
      >
        {{ data?.title }}
      </h2>
      <div
        v-if="!isShowAuthor && getTimeForModel(data.model_type, data)"
        class="ml-auto flex h-fit flex-nowrap items-center whitespace-nowrap text-[14px] font-medium leading-[24px] text-[#949494]"
      >
        <SvgIcon
          name="clock"
          class="size-5 min-h-[20px] min-w-[20px] text-[#949494]"
        />
        <span class="ml-1">{{ getTimeForModel(data.model_type, data) }}</span>
      </div>
      <div
        v-else-if="isShowAuthor && data.authors.length"
        class="ml-auto flex w-full shrink-0 flex-wrap items-center"
      >
        <div
          class="mt-2 flex flex-wrap items-center font-roboto text-[14px] leading-[18px] text-[#949494]"
        >
          <span
            v-for="(author, index) in data.authors"
            :key="author.id"
            class="mb-2"
            >{{ author.fullname
            }}<template v-if="index !== data.authors.length - 1"
              >,&nbsp;</template
            >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const emit = defineEmits(['click:presentation']);

const { getTimeForModel } = useTimeForModel();

const isShowAuthor = computed(() => {
  return props.data?.model_type === 'book';
});

const isPresentation = computed(() => {
  return props.data?.model_type === 'presentation';
});
</script>
